import { Table, TableRow, TableCell, TableHead, TableBody, Checkbox, Button } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import organizationsSAService from "services/superadmin/organizationsSAService";
import { toast } from "react-toastify";

const allModules = [
  "stats",
  "leads",
  "ai-agents",
  "tour-packages",
  "products",
  "customers",
  "contacts",
  "orders",
  "sub-orders",
  "group-trips",
  "members",
  "roles",
  "faq",
  "locations",
  "invoices",
  "broadcasts",
  "reviews",
  "integrations",
  "automations",
  "chats",
  "plans",
  "tasks",
  "tickets",
  "branches",
  "trains",
];

export const OrgModules = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const { data: org, isLoading } = useQuery({
    queryKey: ["org-modules", id],
    queryFn: () => organizationsSAService.get(id),
    select: (data) => data.data,
    retry: false,
    refetchOnWindowFocus: false,
  });

  const [modules, setModules] = useState<string[]>([]);

  useEffect(() => {
    if (org) {
      setModules(org.modules || []);
    }
  }, [org]);

  const handleModuleChange = async (module: string) => {
    if (modules.includes(module)) {
      setModules(modules.filter((m) => m !== module));
    } else {
      setModules([...modules, module]);
    }
  };

  const handleSave = async () => {
    await organizationsSAService.patch(id, { modules: modules });
    toast.success("Модули успешно сохранены");
  };

  return (
    <div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Модуль(системное название)</TableCell>
            <TableCell>Модуль(название)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {allModules.map((module) => (
            <TableRow key={module}>
              <TableCell>
                <Checkbox
                  checked={modules.includes(module) ? true : false}
                  onChange={() => handleModuleChange(module)}
                />
              </TableCell>
              <TableCell>{module}</TableCell>
              <TableCell>{t(module)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <pre>{JSON.stringify(modules, null, 2)}</pre>
      <Button variant="contained" color="primary" onClick={handleSave}>
        {t("save")}
      </Button>
    </div>
  );
};
